<template>
  <div>

    <div v-if="false" class="loading_page">
      <orbit-spinner
          :animation-duration="1000"
          :size="100"
          :color="'#0e96b1'"
      />
    </div>


    <!-- Header: Info -->
    <div class="d-flex mt-3">
      <feather-icon
          icon="InfoIcon"
          size="19"
      />
      <h4 class="mb-0 ml-50">
        {{ $t('General Information')}}
      </h4>
    </div>


    <b-form class="mt-2">
      <b-row>
        <!-- Field: name -->
        <b-col cols="12" md="12">
          <b-form-group :label="$t('Name')" label-for="name">
            <b-form-input
              id="name"
              autocomplate="off"
              v-model="geofenceData.name"
              :state="errors && ('name' in errors) ? false : null"
            />
            <small v-if="errors && errors.name" class="text-danger">
              {{ $t(errors.name[0]) }}
            </small>
          </b-form-group>
        </b-col>

        <!-- Field: category -->
        <b-col cols="12" md="6">
          <b-form-group :label="$t('Category')" label-for="geo-category">
            <v-select
                v-model="geofenceData.category"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :options="lists.categories.map(i=>({id:i,name:$t(i)}))"
                :getOptionLabel="d => d.name" 
                :reduce="d => d.id"
                :clearable="false"
                @input="getGeofenceTypesByCategory($event)"
                input-id="geo-category"
            />
            <small v-if="errors && errors.category" class="text-danger">
              {{ $t(errors.category[0]) }}
            </small>
          </b-form-group>
        </b-col>


        <!-- Field: contract -->
        <b-col cols="12" md="6">
          <b-form-group :label="$t('Contract')" label-for="geo-contract">
            <v-select
                v-model="geofenceData.contract_id"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :options="lists.contracts"
                :reduce="val => val.id"
                :getOptionLabel="c => c.name"
                :clearable="false"
                input-id="geo-contract"
            />
            <small v-if="errors && errors.contract_id" class="text-danger">
              {{ $t(errors.contract_id[0]) }}
            </small>
          </b-form-group>
        </b-col>

        <!-- Field: City -->
        <b-col cols="12" md="6">
          <b-form-group :label="$t('City')" label-for="geo-city">
            <v-select
                @input="(value)=> {
                  $store.commit('geofence/updateCityFilter', {value})
                  $store.commit('geofence/filterDistricts')
                }"
                :value="$store.getters['geofence/cityFilter']"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :options="$store.getters['geofence/cityFilterOptions']"
                :getOptionLabel="c => c.name" 
                :reduce="c => c.id"
                input-id="geo-city"
            />
          </b-form-group>
        </b-col>



          <!-- Field: District -->
        <b-col cols="12" md="6">
          <b-form-group :label="$t('District')" label-for="geo-district">
            <v-select
              @input="(value)=> {
                  $store.commit('geofence/updateDistrictId', {value})
                }"
                :value="$store.getters['geofence/districtId']"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :options="$store.getters['geofence/filteredDistrictOptions']"
                :getOptionLabel="d => d.name" 
                :reduce="d => d.id"
                input-id="geo-district"
            />
            <small v-if="errors && errors.category" class="text-danger">
              {{ $t(errors.category[0]) }}
            </small>
          </b-form-group>
        </b-col>



        <!-- Field: owner -->
       
        <b-col cols="12" md="6" v-if="$store.state.auth.userData.roles.includes('Super Admin')">
          <b-form-group :label="$t('Owner')" label-for="geo-owner">
            <v-select
                v-model="geofenceData.owner_id"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :options="lists.owners"
                :reduce="val => val.id"
                :getOptionLabel="c => c.name"
                :clearable="false"
                input-id="geo-owner"
            />
            <small v-if="errors && errors.owner_id" class="text-danger">
              {{ $t(errors.owner_id[0]) }}
            </small>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" >
          
          <b-form-group :label="$t('Geofence Type')" label-for="geo-owner">
            <v-select
                v-model="geofenceData.type_id"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :options="typesOptions"
                :reduce="val => val.id"
                :getOptionLabel="c => c.name"
                :clearable="false"
                input-id="geo-type"
            />
            <small v-if="errors && errors.type_id" class="text-danger">
              {{ $t(errors.type_id[0]) }}
            </small>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" >
          
          <b-form-group :label="$t('Geofence Types')" label-for="geo-types">
            <v-select
                multiple
                v-model="geofenceData.types"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :options="typesOptions"
                :reduce="val => val.id"
                :getOptionLabel="c => c.name"
                :clearable="false"
                input-id="geo-types"
            />
            <small v-if="errors && errors.types" class="text-danger">
              {{ $t(errors.types[0]) }}
            </small>
          </b-form-group>
        </b-col>


<!--        &lt;!&ndash; Field: calendars &ndash;&gt;-->
<!--        <b-col cols="12" md="6">-->
<!--          <b-form-group :label="$t('Calendar')" label-for="geo-calendar">-->
<!--            <v-select-->
<!--                v-model="geofenceData.calendarId"-->
<!--                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"-->
<!--                :options="lists.calendars"-->
<!--                :reduce="val => val.id"-->
<!--                label="name"-->
<!--                :clearable="false"-->
<!--                input-id="geo-calendar"-->
<!--            />-->

<!--&lt;!&ndash;              <small v-if="errors && ('calendarId' in errors.errors)" class="text-danger">&ndash;&gt;-->
<!--&lt;!&ndash;                {{ $t(errors.errors.calendarId[0]) }}&ndash;&gt;-->
<!--&lt;!&ndash;              </small>&ndash;&gt;-->
<!--          </b-form-group>-->
<!--        </b-col>-->



      </b-row>

    </b-form>

  </div>
</template>

<script>
import {
  BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput,
  BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox,BFormTextarea
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { CirclesToRhombusesSpinner, OrbitSpinner } from 'epic-spinners'
import flatPickr from 'vue-flatpickr-component'
import store from '@/store'
import { computed ,ref,watch} from '@vue/composition-api'

import { getGeofenceGeneralTypes} from '@/app/share/lists'
export default {
  components: {
    flatPickr,
    BButton,
    BMedia,
    BAvatar,
    BRow,
    OrbitSpinner,
    BFormTextarea,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
  },

  setup() {

    const auth = store.state.auth.userData
    const s = store.state.geofence

    const geofenceData = computed(() => s.data)
    const typesOptions=ref([])
    const typesOptions_orig=ref([])
    const errors = computed(() => s.errors)
    getGeofenceGeneralTypes().then(r =>{
      typesOptions.value= r.data.types.data 
      typesOptions_orig.value= r.data.types.data 
       } )
    
    const getTypesByCategory = cat => {
      store.dispatch(
          'geofence/fetchTypesByCategory',
          cat
      )
    }
   
   
const getGeofenceTypesByCategory =(cat)=>{    
   if(cat!=undefined  && cat!= null){
    typesOptions.value=typesOptions_orig.value.filter(g=>g.category==cat)
   }else{
    typesOptions.value=typesOptions_orig.value
   }
  
}

    const lists = computed(() => {

      return {
        owners: [...s.ownersOptions],
        groups: s.groupsOptions,
        contracts: s.contractsOptions,
        categories: s.categoriesOptions,
        districts:s.districtsOptions,
        types: s.typesOptions,
       
      }
    })

    const cityFilter = ref('');

    return {
      getTypesByCategory,
      lists,
      geofenceData,
      errors,
      getGeofenceTypesByCategory,
      typesOptions
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
